// extracted by mini-css-extract-plugin
export default {"empty":"EmptyStory_empty__RjuV7","img":"EmptyStory_img__N0A5g","title":"EmptyStory_title__+nOzt"};